import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { orderApprovalDetailsActionButtonsStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsActionButtons";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

orderApprovalDetailsActionButtonsStyles.deleteButton = mergeToNew(orderApprovalDetailsActionButtonsStyles.deleteButton, {
    css: css`
      margin-left: 10px;
      &:focus {
        outline: none;
      }
    `
});

orderApprovalDetailsActionButtonsStyles.printButton = mergeToNew(orderApprovalDetailsActionButtonsStyles.printButton, {
  css: css`
    &:focus {
      outline: none;
    }
  `
});

orderApprovalDetailsActionButtonsStyles.approveButton = mergeToNew(orderApprovalDetailsActionButtonsStyles.approveButton, {
  css: css`
    margin-left: 10px;
    &:focus {
      outline: none;
    }
  `
});
